module.exports = __webpack_public_path__ + "img/phoneIcon.a5abb1c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/phoneIcon.svg
// module id = ./assets/phoneIcon.svg
// module chunks = 13